import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import MEIElectricBikesCard from 'src/components/reports/reportsBoard/MEIReportsCards/MEIElectricBikesCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const MEIElectricBikesPage = props => {
  const { selectedDate, handleDateChange } = props

  const history = useHistory()
  const classes = useStyles()

  return (
    <>
      <CardTitle
        title="Ventas totales bicicletas eléctricas"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <MEIElectricBikesCard {...props} />
    </>
  )
}

export default MEIElectricBikesPage
